import React from "react";
import ReactDOM from "react-dom";
import "./i18n";
import App from "./App";
import { ThemeProvider } from "styled-components";
import "./index.css";
import store from "./store";
import { Provider } from "react-redux";

import { theme, GlobalStyle } from "./style";

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <GlobalStyle />
      <App />
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);

